import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { articles } from '../components/Insights';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function ArticleDetail() {
  const { id } = useParams();
  const article = articles.find(a => a.id === id);

  if (!article) return <div className="py-40 text-center">Article not found</div>;

  return (
    <article className="pt-32 pb-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <Link to="/#insights" className="inline-flex items-center text-amber-600 font-medium mb-8 hover:gap-2 transition-all">
          <SafeIcon icon={FiIcons.FiArrowLeft} className="mr-2" />
          Back to Insights
        </Link>
        
        <header className="mb-12">
          <div className="text-amber-600 font-semibold uppercase tracking-widest text-sm mb-4">{article.category}</div>
          <h1 className="text-4xl md:text-6xl font-serif text-slate-900 leading-tight mb-6">{article.title}</h1>
          <div className="flex items-center gap-6 text-slate-500 text-sm border-y border-slate-100 py-4">
            <span>Published {article.date}</span>
            <span>By Eldenwyck Research Team</span>
            <span>8 min read</span>
          </div>
        </header>

        <img src={article.image} alt={article.title} className="w-full h-[400px] object-cover mb-12 shadow-lg" />

        <div className="prose prose-slate prose-lg max-w-none text-slate-600 leading-relaxed font-light">
          <p className="text-xl text-slate-900 font-medium mb-8 italic">
            {article.excerpt}
          </p>
          <h2 className="text-2xl font-serif text-slate-900 mt-12 mb-6">Strategic Overview</h2>
          <p className="mb-6">
            In today's rapidly evolving market, the ability to anticipate shifts before they become mainstream is the hallmark of industry leaders. We have analyzed over 500 global organizations to understand how they are positioning themselves for the next decade.
          </p>
          <p className="mb-6">
            The data suggests a significant pivot toward integrated technological resilience. It is no longer enough to have a digital strategy; one must have a business strategy that is digital at its core.
          </p>
          <blockquote className="border-l-4 border-amber-600 pl-6 my-10 text-slate-900 italic font-medium">
            "The organizations that will thrive in 2025 are those that view complexity not as a hurdle, but as a catalyst for innovation."
          </blockquote>
          <h2 className="text-2xl font-serif text-slate-900 mt-12 mb-6">Key Findings</h2>
          <ul className="list-disc pl-6 space-y-4 mb-8">
            <li>Accelerated adoption of generative AI across operational workflows.</li>
            <li>Shift from global optimization to regional resilience in logistics.</li>
            <li>The emergence of "Sustainable ROI" as a primary metric for investors.</li>
          </ul>
          <p>
            As we move forward, Eldenwyck & Co. remains committed to providing the clarity and strategic foresight required to navigate these challenges. For a detailed consultation on how these findings impact your specific industry vertical, contact our regional partners.
          </p>
        </div>
      </div>
    </article>
  );
}